module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.date !== null) ? _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            Available rooms \n\n            "), _c('small', [_vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.date, "MMMM \'YY")) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-xs"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'MMMM YYYY'
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('print'), _vm._v(" \n            ")], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-xs"
  })])]), _vm._v(" "), _vm._l((_vm.days), function(n) {
    return (_vm.types.length) ? _c('available-rooms', {
      key: n,
      attrs: {
        "date": _vm.dayOfMonth(n),
        "types": _vm.types
      }
    }) : _vm._e()
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fffd9966","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rooms/Available.vue
// module id = 410
// module chunks = 1